import React from "react";
import { ScrollView, Text } from "react-native";
import { Stack, useRouter } from "expo-router";
import { MoreHorizontalIcon } from "lucide-react-native";
import { observer } from "mobx-react-lite";

import { useAccountActions } from "~/components/AccountActions/context";
import {
  StackHeaderBack,
  StackHeaderRight,
  StackHeaderTitle,
} from "~/components/HeaderElements";
import {
  WorkspaceActions,
  WorkspaceMenu,
} from "~/components/Workspace/WorkspaceMenu";
import { backlogSlug } from "~/app/(app)/(authenticated)/[account]/(account)/backlog";
import { useCurrentSpace } from "~/hooks/useCurrentSpace";
import { icons, isWebDesktop } from "~/lib/constants";
import { AccountType, Space } from "~/stores/space/store";
import { Dropdown } from "~/ui/Dropdown";

function SpaceIndexPage() {
  const { account, space } = useCurrentSpace();
  const { replace } = useRouter();
  const accountActions = useAccountActions();
  React.useEffect(() => {
    if (!isWebDesktop()) return;

    replace({
      pathname: "/(app)/(authenticated)/[account]/(space)/[space]/saves",
      params: {
        account: account.slug,
        space: space.slug,
      },
    });
  }, [account.slug, replace, space.slug]);

  return (
    <>
      <Stack.Screen
        options={{
          headerLeft: () => <StackHeaderBack backPath={`/${account.slug}`} />,
          headerTitle: () => (
            <StackHeaderTitle>
              {space.displayName ?? space.slug}
            </StackHeaderTitle>
          ),
          headerRight: () => (
            <StackHeaderRight>
              <WorkspaceActions
                trigger={
                  <Text className="text-text-primary">
                    <MoreHorizontalIcon size={24} />
                  </Text>
                }
              />
            </StackHeaderRight>
          ),
        }}
      />
      <ScrollView className="px-4 py-4">
        <WorkspaceMenu />
      </ScrollView>
    </>
  );
}

function HeaderMenu(props: { account: AccountType; space: Space }) {
  const { account, space } = props;

  const { push } = useRouter();

  return (
    <>
      <Dropdown
        trigger={
          <Text className="text-text-primary">
            <MoreHorizontalIcon size={24} />
          </Text>
        }
        groups={[
          {
            items: (
              [
                {
                  key: "Edit",
                  title: "Edit",
                  icon: icons.edit,
                  onSelect: () => {
                    push({
                      pathname: "/(app)/(authenticated)/[account]/spaceForm",
                      params: {
                        account: account.slug,
                        spaceId: space?.id,
                      },
                    });
                  },
                },

                {
                  key: "newCollection",
                  title: "New collection",
                  icon: icons.collection,
                  onSelect: () => {
                    push({
                      pathname:
                        "/(app)/(authenticated)/[account]/collection/form",
                      params: {
                        account: account.slug,
                        spaceId: space?.id,
                      },
                    });
                  },
                },

                // {
                //   key: "Share",
                //   title: "Share",
                //   icon: {
                //     ios: "square.and.arrow.up",
                //     web: "share",
                //   },
                // },
                {
                  key: "Delete",
                  title: "Delete",
                  icon: icons.delete,

                  destructive: true,
                },
              ] as const
            ).filter((item) => {
              if (space.slug === backlogSlug && item.key === "newCollection")
                return false;
              return true;
            }),
          },
        ]}
      />
    </>
  );
}

export default observer(SpaceIndexPage);
